import React from 'react';

import ShipmentStatusIcon from '../../components/shipment-status-icon';
import { noop } from 'ui-components/default-props/noop';

import styles from './shipment-status-card.module.less';

/**
 * @param {object} props
 * @param {'' | 'error' | 'completed' | 'processing' | 'shipped'} [props.status]
 * @param {string} [props.title]
 * @param {string} [props.message]
 * @param {import('@fortawesome/fontawesome-common-types').IconDefinition} props.icon
 * @param {React.ReactNode | React.ReactNode[]} [props.tooltipContent]
 * @param {() => void} [props.onIconClick]
 * @param {boolean} [props.clickable]
 * @param {string} [props.iconStyle]
 * @returns {JSX.Element}
 */
const ShipmentStatusCard = ({
  status = '',
  title = '',
  message = null,
  icon,
  tooltipContent = null,
  onIconClick = noop,
  clickable = false,
  iconStyle = '',
}) => {
  return (
    <div className={styles['status-card-wrapper']}>
      <div className={styles.content}>
        <div className={styles.title}>{title}</div>
        <div className={styles.message}>{message || <span>&mdash;</span>}</div>
      </div>
      <div className={styles.icon}>
        <ShipmentStatusIcon
          clickable={clickable}
          icon={icon}
          iconStyle={iconStyle}
          onClick={onIconClick}
          status={status}
          tooltipContent={tooltipContent}
        />
      </div>
    </div>
  );
};

export default ShipmentStatusCard;
